import { getCurrencyCodeParam, getQueryParams } from '../utils/queryUtils';
export const getCurrencyCodeUnit = ({
  countryCode,
  defaultCurrencyCode
}) => {
  if (countryCode !== 'US' && defaultCurrencyCode === 'USD') {
    return 'US$';
  }

  // Returned undefined to for proper type matching with the CurrencyStore type and FormattedIntlCurrency
  return undefined;
};
export const getShowCurrencyCodeUnit = ({
  currencyCode,
  currencyCodeUnit
}) => {
  // We don't want to show the currencyCodeUnit if it is undefined
  return currencyCode === 'USD' && !!currencyCodeUnit;
};
export const getDisplayedCurrencyCode = ({
  lockedCurrencyCode,
  defaultCurrencyCode
}) => {
  const currencyCodeParam = getCurrencyCodeParam(getQueryParams());
  return lockedCurrencyCode || currencyCodeParam || defaultCurrencyCode;
};
export const getCurrencyStoreResponse = response => {
  const {
    countryCode,
    defaultCurrencyCode,
    lockedCurrencyCode
  } = response;
  const currencyCodeUnit = getCurrencyCodeUnit({
    countryCode,
    defaultCurrencyCode
  });
  const showCurrencyCodeUnit = getShowCurrencyCodeUnit({
    currencyCode: defaultCurrencyCode,
    currencyCodeUnit
  });
  const displayedCurrencyCode = getDisplayedCurrencyCode({
    lockedCurrencyCode,
    defaultCurrencyCode
  });
  return Object.assign({
    currencyCodeUnit,
    showCurrencyCodeUnit,
    displayedCurrencyCode
  }, response);
};